var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3477",
  "data-name": "Group 3477",
  transform: "translate(-392 -1320)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1668",
  "data-name": "Rectangle 1668",
  d: "M2,0H22a2,2,0,0,1,2,2V24a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
  transform: "translate(392 1320)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3459",
  "data-name": "Group 3459",
  transform: "translate(-1 9)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2193",
  "data-name": "Group 2193",
  transform: "translate(400 1325.58)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2192",
  "data-name": "Group 2192"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M26.681,307.2a.365.365,0,0,0-.385.342v2.052a.365.365,0,0,1-.385.342H18.22a.365.365,0,0,1-.385-.342v-2.052a.387.387,0,0,0-.769,0v2.052a1.1,1.1,0,0,0,1.154,1.026h7.692a1.1,1.1,0,0,0,1.154-1.026v-2.052A.365.365,0,0,0,26.681,307.2Z",
  transform: "translate(-17.066 -307.2)",
  fill: "#1370fc"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2195",
  "data-name": "Group 2195",
  transform: "translate(402.72 1317)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2194",
  "data-name": "Group 2194",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M141.186,6.572a.381.381,0,0,0-.529,0L139.4,7.823V.38a.381.381,0,0,0-.761,0V7.823l-1.254-1.251a.38.38,0,0,0-.538.537l1.9,1.9a.381.381,0,0,0,.538,0h0l1.9-1.9A.379.379,0,0,0,141.186,6.572Z",
  transform: "translate(-136.742 0)",
  fill: "#1370fc"
})))))));
export default __webpack_public_path__ + "static/media/download-bg.3024eb6a.svg";
export { SvgComponent as ReactComponent };